import { Popover } from 'antd'
import FilterForm from './FilterForm'
import styles from '../../../../../testrun.module.css'

// Selects portal their dropdown to <body> by default, which the popover reads
// as an outside click and closes on. Render them inside the popover instead.
const getSelectPopupContainer = (trigger) => trigger.parentNode

const FilterPopover = (props) => {
    const {
        stateTestRun,
        setStateTestRun = () => {},
        projectId,
        children,
    } = props

    const isOpen = stateTestRun?.filterPopover || false

    const handleOpenChange = (open) => {
        setStateTestRun({ ...stateTestRun, filterPopover: open })
    }

    const handleClose = () => {
        setStateTestRun({ ...stateTestRun, filterPopover: false })
    }

    return (
        <Popover
            arrow={false}
            trigger="click"
            placement="bottomRight"
            title={null}
            open={isOpen}
            onOpenChange={handleOpenChange}
            rootClassName={styles.filterPopover}
            content={
                <FilterForm
                    stateTestRun={stateTestRun}
                    setStateTestRun={setStateTestRun}
                    handleClose={handleClose}
                    projectId={projectId}
                    getPopupContainer={getSelectPopupContainer}
                />
            }
        >
            {children}
        </Popover>
    )
}

export default FilterPopover
